module.exports = __webpack_public_path__ + "img/team.aa06150f.svg";